import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex gap-6 align-items-center justify-content-center" }
const _hoisted_2 = { class: "mt-4" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Party Id", -1)
const _hoisted_5 = { class: "ms-2" }
const _hoisted_6 = { class: "d-flex align-items-center gap-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right fa-2x" }, null, -1)
const _hoisted_8 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_9 = { class: "d-flex justify-content-between" }
const _hoisted_10 = { class: "ms-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_13 = { class: "d-flex justify-content-between" }
const _hoisted_14 = { class: "ms-2" }
const _hoisted_15 = { class: "d-flex justify-content-between" }
const _hoisted_16 = { class: "ms-2" }
const _hoisted_17 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = { class: "ms-2" }
const _hoisted_20 = { class: "d-flex justify-content-between" }
const _hoisted_21 = { class: "ms-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right fa-2x" }, null, -1)
const _hoisted_23 = { class: "mt-4" }
const _hoisted_24 = { class: "d-flex justify-content-between" }
const _hoisted_25 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_26 = { class: "d-flex justify-content-between" }
const _hoisted_27 = { class: "ms-2" }
const _hoisted_28 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_29 = { class: "d-flex justify-content-between" }
const _hoisted_30 = { class: "dialog-footer" }

import { ref } from "vue";
import AccountService from "@/projects/tenant/modules/accounts/services/AccountService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import OpenWholeSaleAccount from "./OpenWholeSaleAccount.vue";
import notification from "@/core/plugins/notification";

const enum DataStatus {
  pending = 1,
  approved = 2,
  rejected = 3,
  completed = 4,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'wholesaleReferralDetail',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {

const dialogRef = ref(false);
const openWholeSaleAccountRef = ref();
const data = ref<any>({});
const name = ref("");
const isSubmitting = ref(false);
const formData = ref({} as any);



const openAccounts = () => {
  openWholeSaleAccountRef.value?.show(data.value.supplement.partyId);
};

const reject = async () => {
  try {
    isSubmitting.value = true;
    await AccountService.rejectApplicationsById(data.value.id, formData.value);
    MsgPrompt.success().then(() => {
      emits("submit");
      dialogRef.value = false;
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isSubmitting.value = false;
  }
};

const approve = async () => {
  try {
    isSubmitting.value = true;
    await AccountService.approveApplicationsById(data.value.id, formData.value);
    MsgPrompt.success().then(() => {
      emits("submit");
      dialogRef.value = false;
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isSubmitting.value = false;
  }
};

const approveAndCreate = async () => {
  try {
    isSubmitting.value = true;
    await AccountService.approveApplicationsById(data.value.id, formData.value);
    notification.success();
    emits("submit");
    openWholeSaleAccountRef.value?.show(data.value.supplement.partyId);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isSubmitting.value = false;
  }
};

const accountOpened = () => {
  dialogRef.value = false;
  emits("submit");
};

const getTagColor = (status: number) => {
  switch (status) {
    case DataStatus.pending:
      return "warning";
    case DataStatus.approved:
      return "success";
    case DataStatus.rejected:
      return "danger";
    case DataStatus.completed:
      return "success";
    default:
      return "info";
  }
};
const show = (_data: any) => {
  data.value = _data;
  name.value = data.value.user.nativeName;
  dialogRef.value = true;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogRef).value = $event)),
    title: name.value,
    width: "1200",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_30, [
        (data.value.status == DataStatus.pending)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              plain: "",
              type: "danger",
              loading: isSubmitting.value,
              onClick: reject
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.reject")), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        (data.value.status != DataStatus.approved)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "success",
              plain: "",
              loading: isSubmitting.value,
              onClick: approve
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.approve")), 1)
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        (
            data.value.hasWholesaleAccount === false &&
            data.value.status == DataStatus.approved
          )
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              plain: "",
              loading: isSubmitting.value,
              onClick: openAccounts
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Create Pro Account ")
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        (
            data.value.hasWholesaleAccount === false &&
            data.value.status != DataStatus.approved
          )
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 3,
              type: "primary",
              plain: "",
              loading: isSubmitting.value,
              onClick: approveAndCreate
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Approve and Create Pro Account ")
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_card, { style: {"max-width":"480px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tag, {
                type: "warning",
                plain: "",
                round: "",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("fields.referrer")), 1)
                ]),
                _: 1
              }),
              (data.value.user)
                ? (_openBlock(), _createBlock(_component_UserInfo, {
                    key: 0,
                    user: data.value.user,
                    class: "me-2"
                  }, null, 8, ["user"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("span", _hoisted_5, _toDisplayString(data.value.user.partyId), 1)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_tag, {
                type: "info",
                plain: "",
                round: "",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("fields.info")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.status")), 1),
                _createVNode(_component_el_tag, {
                  class: "ms-2",
                  type: getTagColor(data.value.status)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("status." + DataStatus[data.value.status])), 1)
                  ]),
                  _: 1
                }, 8, ["type"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_TimeShow, {
                    "date-iso-string": data.value.createdOn
                  }, null, 8, ["date-iso-string"])
                ])
              ]),
              _hoisted_11,
              (data.value.rejectedOn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("status.rejected")), 1),
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": data.value.rejectedOn
                        }, null, 8, ["date-iso-string"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.operator")), 1),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(data.value.rejectedBy), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (data.value.approvedOn)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("status.approved")), 1),
                      _createElementVNode("span", _hoisted_19, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": data.value.approvedOn
                        }, null, 8, ["date-iso-string"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.operator")) + " PartyId", 1),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(data.value.approvedBy), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _hoisted_22
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_card, { style: {"max-width":"480px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tag, {
                type: "success",
                plain: "",
                round: "",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("fields.referee")), 1)
                ]),
                _: 1
              }),
              (data.value.supplement)
                ? (_openBlock(), _createBlock(_component_UserInfo, {
                    key: 0,
                    name: data.value.supplement.name,
                    email: data.value.supplement.email,
                    partyId: data.value.supplement.partyId,
                    class: "me-2"
                  }, null, 8, ["name", "email", "partyId"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.hasProAccount")), 1),
                  _createVNode(_component_el_text, {
                    type: data.value.hasWholesaleAccount ? 'success' : 'danger',
                    class: "ms-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.value.hasWholesaleAccount ? "Yes" : "No"), 1)
                    ]),
                    _: 1
                  }, 8, ["type"])
                ])
              ]),
              (data.value.refererPartyId != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.referrerPartyId")), 1),
                      _createElementVNode("span", _hoisted_27, _toDisplayString(data.value.refererPartyId), 1)
                    ]),
                    _createVNode(_component_el_tag, {
                      type: "danger",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("tip.wholesaleReferTip")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("fields.hasReferrer")), 1),
                      _createVNode(_component_el_text, {
                        type: "danger",
                        class: "ms-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.no")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(OpenWholeSaleAccount, {
        ref_key: "openWholeSaleAccountRef",
        ref: openWholeSaleAccountRef,
        onApplicationSubmitted: accountOpened
      }, null, 512)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})